const typeaheadPointer = {
  data () {
    return {
      typeAheadPointer: -1
    }
  },

  watch: {
    options () {
      this.typeAheadPointer = -1
    }
  },

  methods: {
    /**
     * Move the typeAheadPointer visually up the list by
     * subtracting the current index by one.
     * @return {void}
     */
    typeAheadUp () {
      if (this.typeAheadPointer > 0) {
        this.typeAheadPointer--
        if (this.isHeader(this.options[this.typeAheadPointer]) && this.typeAheadPointer > 0) {
          this.typeAheadPointer--
        }
      }
    },

    /**
     * Move the typeAheadPointer visually down the list by
     * adding the current index by one.
     * @return {void}
     */
    typeAheadDown () {
      if (this.typeAheadPointer < this.options.length - 1) {
        this.typeAheadPointer++
        if (this.isHeader(this.options[this.typeAheadPointer])) {
          this.typeAheadPointer++
        }
      }
    },

    /**
     * Select the option at the current typeAheadPointer position.
     * Optionally clear the search input on selection.
     * @return {void}
     */
    typeAheadSelect () {
      if (this.options[this.typeAheadPointer]) {
        this.updateValue(this.options[this.typeAheadPointer])
      }
    }
  }
}

export default typeaheadPointer
